module.exports = __webpack_public_path__ + "static/media/waist.5ed13bdc.svg";